var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgPrgGeniusM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_4544",
    "data-name": "Raggruppa 4544",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.771,
    height: 41.954,
    viewBox: "0 0 34.771 41.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.088,
    y1: 0.017,
    x2: 0.591,
    y2: 0.711,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6ffeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50761a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#255300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96d665"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6ffeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#255300"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9562",
    "data-name": "Tracciato 9562",
    d: "M309.58,1384.313l16.541-16.541c.013-.271.021-.544.021-.819a17.331,17.331,0,0,0-5.925-13.067l-11.46-11.505-11.461,11.5a17.382,17.382,0,0,0,11.46,30.454C309.032,1384.335,309.306,1384.327,309.58,1384.313Z",
    transform: "translate(-291.371 -1342.381)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9563",
    "data-name": "Tracciato 9563",
    d: "M450.03,1628.308c-.291-.118-.608-.254-.894-.386l-.781-.354.073.854a10.147,10.147,0,0,0,1.882,5.02l-1.461-.334.193.789a9.983,9.983,0,0,0,3.147,5.351c-.149,0-.316.005-.506.005-.235,0-.4,0-.4,0l-.8-.018.333.727c.643,1.408,2.593,2.916,4.158,3.956l11.723-11.721,3.212-3.431a66.216,66.216,0,0,0-14.817-5.4c.059.1.117.19.171.284a15.851,15.851,0,0,0-4.3-.6c-.824,0-1.29.053-1.478.32a.681.681,0,0,0-.111.181",
    transform: "translate(-436.639 -1602.103)",
    fill: "#72ac45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4543",
    "data-name": "Raggruppa 4543",
    transform: "translate(13.804 19.508)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9564",
    "data-name": "Tracciato 9564",
    d: "M476.346,1609.14a11.33,11.33,0,0,0,1.969,6.618L476.38,1615c.464,3.922,2.32,5.99,2.941,6.482s-1.908.117-1.908.117c.462,1.588,2.378,3.567,3.412,4.548l16.486-16.533a8.76,8.76,0,0,0-2.551-2.4s-.091,2.56-.457,1.854a10.125,10.125,0,0,0-5.793-4.118l.379,2.039a11.405,11.405,0,0,0-6.109-3.186s1.016,2.349.578,2.014c-1.787-1.386-5.605-1.867-5.667-1.605-.255.015-.507,3.848.519,5.886C478.451,1610.574,476.346,1609.14,476.346,1609.14Z",
    transform: "translate(-476.344 -1603.802)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9565",
    "data-name": "Tracciato 9565",
    d: "M494.629,1633.9a11.028,11.028,0,0,1-1.374-1.705c.219-.143,1.593-.364,2.562-.614,0,0-1.251-1.03-1.744-1.426a8.256,8.256,0,0,1-2.249-4.1,4.7,4.7,0,0,1,1.993.134s-2.189-3.259-2.205-5.721a9.98,9.98,0,0,0,1.8.362,15.318,15.318,0,0,1-.751-6.614,15.968,15.968,0,0,1,5.6,2.194c.336,0-.041-1.79-.188-2.382a21.287,21.287,0,0,1,5.656,3.541c.814-.406.188-2.225.188-2.225a13.018,13.018,0,0,1,4.644,4.312h0c.658,0,.857-1.365.7-2.4a13.059,13.059,0,0,1,1.938,1.85l-5.344,4.576c-4.256-3.9-8-5.2-8.188-5.2,0,0,4.6,3.259,6.813,6.519Z",
    transform: "translate(-490.473 -1613.268)",
    opacity: 0.8,
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgPrgGeniusM);
export default __webpack_public_path__ + "static/media/SvgPrgGeniusM.3a5e5b5e4e86d2790befc5de2630ae2b.svg";
export { ForwardRef as ReactComponent };